import React, { useState, useEffect } from 'react';
import api from '../../../../../config/axios';
import Swal from 'sweetalert2';

import { FaRegSave, FaTimes } from 'react-icons/fa';

const CategoriaFinanceiraModal = ({ categoriaFinanceira, onClose, onCategoriaFinanceiraAtualizada }) => {
    const [formData, setFormData] = useState({
        nome: '',
        codigo_contabil: '',
        codigo_reduzido: '',
        tipo_contabil: 'receita',
        tipo_financeiro: 'receita',
        grupo_dre_id: '',
        categoria_pai_id: '',
        classe_fluxo_caixa: 'O',
        vai_dre: 'S',
        doar_tag: 'ORIGEM',
        ativo: true,
        tipo_vinculo: 'gestora'
    });
    const [tituloModal, setTituloModal] = useState("");
    const [gruposDre, setGruposDre] = useState([]);
    const [categoriasPai, setCategoriasPai] = useState([]);

    useEffect(() => {
        if (categoriaFinanceira != null) {
            setFormData({
                nome: categoriaFinanceira.nome || '',
                codigo_contabil: categoriaFinanceira.codigo_contabil || '',
                codigo_reduzido: categoriaFinanceira.codigo_reduzido || '',
                tipo_contabil: categoriaFinanceira.tipo_contabil || 'receita',
                tipo_financeiro: categoriaFinanceira.tipo_financeiro || 'receita',
                grupo_dre_id: categoriaFinanceira.grupo_dre_id || '',
                categoria_pai_id: categoriaFinanceira.categoria_pai_id || '',
                classe_fluxo_caixa: categoriaFinanceira.classe_fluxo_caixa || 'O',
                vai_dre: categoriaFinanceira.vai_dre || 'S',
                doar_tag: categoriaFinanceira.doar_tag || 'ORIGEM',
                ativo: categoriaFinanceira.ativo !== undefined ? categoriaFinanceira.ativo : true,
                tipo_vinculo: categoriaFinanceira.tipo_vinculo || 'gestora'
            });
            setTituloModal('Editar Categoria Financeira');
        } else {
            setTituloModal('Nova Categoria Financeira');
        }

        fetchGruposDre();
        fetchCategoriasPai();
    }, [categoriaFinanceira]);

    const fetchGruposDre = async () => {
        try {
            const response = await api.get('/grupos-dre?limit=1000');
            setGruposDre(response.data.records || []);
        } catch (error) {
            Swal.fire('Erro', 'Erro ao carregar grupos DRE.', 'error');
        }
    };

    const fetchCategoriasPai = async () => {
        try {
            const response = await api.get('/categorias-financeiras?limit=1000');
            setCategoriasPai(response.data.records || []);
        } catch (error) {
            Swal.fire('Erro', 'Erro ao carregar categorias pai.', 'error');
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        let finalValue = value;
        
        if (name === 'ativo') {
            finalValue = value === 'true';
        } else if (type === 'checkbox') {
            finalValue = checked;
        }
        
        setFormData(prev => ({
            ...prev,
            [name]: finalValue
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.nome.trim()) {
            Swal.fire('Atenção', 'O nome da categoria financeira deve ser preenchido.', 'warning');
            return;
        }

        Swal.fire({
            title: "Carregando...",
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            const dataToSend = {
                ...formData,
                codigo_reduzido: formData.codigo_reduzido ? parseInt(formData.codigo_reduzido) : null,
                grupo_dre_id: formData.grupo_dre_id || null,
                categoria_pai_id: formData.categoria_pai_id || null
            };

            if (categoriaFinanceira) {
                await api.put(`/categorias-financeiras/${categoriaFinanceira.id}`, dataToSend);
                Swal.fire("Sucesso", "Categoria financeira atualizada com sucesso!", "success");
            } else {
                await api.post('/categorias-financeiras', dataToSend);
                Swal.fire("Sucesso", "Categoria financeira criada com sucesso!", "success");
            }

            onCategoriaFinanceiraAtualizada();
        } catch (error) {
            Swal.close();
            Swal.fire('Erro', error.response.data.message || 'Erro ao salvar categoria financeira.', 'error');
        }
    };

    return (
        <div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered">
                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                    <div className="modal-header">
                        <h4 className="fw-bold mt-2">{tituloModal}</h4>
                        <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
                    </div>

                    <div className="modal-body">
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-lg-4 col-12">
                                    <label className="form-label fw-bold">Nome</label>
                                    <input
                                        type="text"
                                        name="nome"
                                        className="form-control"
                                        value={formData.nome}
                                        onChange={handleChange}
                                        maxLength={255}
                                        required
                                        autoComplete="off"
                                    />
                                </div>
                                <div className="col-lg-4 col-12 mt-lg-0 mt-3">
                                    <label className="form-label fw-bold">Categoria Pai</label>
                                    <select
                                        name="categoria_pai_id"
                                        className="form-control"
                                        value={formData.categoria_pai_id}
                                        onChange={handleChange}
                                    >
                                        <option value="">Nenhuma (categoria principal)</option>
                                        {categoriasPai
                                            .filter(cat => !categoriaFinanceira || cat.id !== categoriaFinanceira.id)
                                            .map((categoria) => (
                                            <option key={categoria.id} value={categoria.id}>
                                                {categoria.nome}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-lg-4 col-12 mt-lg-0 mt-3">
                                    <label className="form-label fw-bold">Tipo de Vínculo</label>
                                    <select
                                        name="tipo_vinculo"
                                        className="form-control"
                                        value={formData.tipo_vinculo}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="gestora">Gestora</option>
                                        <option value="unidade">Unidade</option>
                                    </select>
                                </div>
                            </div>

                            <div className="row mt-3">
                                <div className="col-lg-4 col-12">
                                    <label className="form-label fw-bold">Tipo Financeiro</label>
                                    <select
                                        name="tipo_financeiro"
                                        className="form-control"
                                        value={formData.tipo_financeiro}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="receita">Receita</option>
                                        <option value="despesa">Despesa</option>
                                    </select>
                                </div>
                                <div className="col-lg-4 col-12 mt-lg-0 mt-3">
                                    <label className="form-label fw-bold">Grupo DRE</label>
                                    <select
                                        name="grupo_dre_id"
                                        className="form-control"
                                        value={formData.grupo_dre_id}
                                        onChange={handleChange}
                                    >
                                        <option value="">Selecione um grupo DRE</option>
                                        {gruposDre.map((grupo) => (
                                            <option key={grupo.id} value={grupo.id}>
                                                {grupo.ordem} - {grupo.nome}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-lg-4 col-12 mt-lg-0 mt-3">
                                    <label className="form-label fw-bold">Status</label>
                                    <select
                                        name="ativo"
                                        className="form-control"
                                        value={formData.ativo}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value={true}>Ativo</option>
                                        <option value={false}>Inativo</option>
                                    </select>
                                </div>
                            </div>

                            <div className="row mt-3">
                                <div className="col-lg-4 col-12">
                                    <label className="form-label fw-bold">Tipo Contábil</label>
                                    <select
                                        name="tipo_contabil"
                                        className="form-control"
                                        value={formData.tipo_contabil}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="receita">Receita</option>
                                        <option value="despesa">Despesa</option>
                                        <option value="custo">Custo</option>
                                        <option value="deducao">Dedução</option>
                                    </select>
                                </div>
                                <div className="col-lg-4 col-12 mt-lg-0 mt-3">
                                    <label className="form-label fw-bold">Código Contábil</label>
                                    <input
                                        type="text"
                                        name="codigo_contabil"
                                        className="form-control"
                                        value={formData.codigo_contabil}
                                        onChange={handleChange}
                                        maxLength={50}
                                        autoComplete="off"
                                    />
                                </div>
                                <div className="col-lg-4 col-12 mt-lg-0 mt-3">
                                    <label className="form-label fw-bold">Código Reduzido</label>
                                    <input
                                        type="number"
                                        name="codigo_reduzido"
                                        className="form-control"
                                        value={formData.codigo_reduzido}
                                        onChange={handleChange}
                                        min="1"
                                        autoComplete="off"
                                    />
                                </div>
                            </div>

                            <div className="row mt-3">
                                <div className="col-lg-3 col-12">
                                    <label className="form-label fw-bold">Classe Fluxo Caixa</label>
                                    <select
                                        name="classe_fluxo_caixa"
                                        className="form-control"
                                        value={formData.classe_fluxo_caixa}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="O">Operacional</option>
                                        <option value="I">Investimento</option>
                                        <option value="F">Financiamento</option>
                                    </select>
                                </div>
                                <div className="col-lg-3 col-12 mt-lg-0 mt-3">
                                    <label className="form-label fw-bold">Vai DRE</label>
                                    <select
                                        name="vai_dre"
                                        className="form-control"
                                        value={formData.vai_dre}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="S">Sim</option>
                                        <option value="N">Não</option>
                                    </select>
                                </div>
                                <div className="col-lg-3 col-12 mt-lg-0 mt-3">
                                    <label className="form-label fw-bold">Tag DOAR</label>
                                    <select
                                        name="doar_tag"
                                        className="form-control"
                                        value={formData.doar_tag}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="ORIGEM">Origem</option>
                                        <option value="APLICACAO">Aplicação</option>
                                    </select>
                                </div>
                            </div>
                        </form>
                    </div>

                    <div className="modal-footer mt-4">
                        <div className="row">
                            <div className="col-12 text-end">
                                <button className="btn btn-outline-danger" type="button" onClick={onClose}>
                                    <FaTimes /> Fechar
                                </button>
                                <button className="btn btn-custom-primary ms-3" type="submit" onClick={handleSubmit}>
                                    <FaRegSave /> Salvar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CategoriaFinanceiraModal; 